import React from "react";
import {Button, Message} from "semantic-ui-react";
import {FormattedHTMLMessage as MSGS} from "react-intl";
import {Icon} from "semantic-ui-react"

interface IProperties {
    redirectUri?: string;
    authorizationCode: string;
    tppState?: string;
}

/**
 * Страница перенаправление пользователя в TPP после авторизации консента.
 * Если был передан параметр redirectUri, будет отображаться кнопка редиректа.
 */
export default class Redirect extends React.Component<IProperties> {

    render()
    {
        if (this.props.redirectUri)
        {
            let urlString  = this.props.redirectUri;
            if (!urlString.startsWith("http"))
                urlString = "https://" + urlString;

            let url = new URL(urlString);
            url.searchParams.set("code", this.props.authorizationCode);
            if (this.props.tppState)
                url.searchParams.set("state", this.props.tppState);

            return (
                <div>
                    <div className={"app-text"}><MSGS id="redirect_first_line"/></div>
                    <div className="icon-center-container">
                        <Icon name='check circle'/>
                        <div className={"app-subtext"}><MSGS id="redirect_consent_authorization_success_line"/></div>
                    </div>
                    <div className={"page-footer"}>
                        <Button fluid
                                href={url}
                                content={<MSGS id="redirect_button"/>}/>
                    </div>
                </div>
            )
        }

        return (
            <div>
                <div className={"app-text"}><MSGS id="redirect_first_line"/></div>
                <div className={"app-text"}><MSGS id="redirect_auth_code"/></div>
                <Message className={"word-wrap"}>
                    {this.props.authorizationCode}
                </Message>
            </div>
        )
    }
}